import { render } from "./AppInfoModale.vue?vue&type=template&id=10907bb6&scoped=true&ts=true"
import script from "./AppInfoModale.vue?vue&type=script&lang=ts"
export * from "./AppInfoModale.vue?vue&type=script&lang=ts"

import "./AppInfoModale.vue?vue&type=style&index=0&id=10907bb6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10907bb6"]])

export default __exports__